import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../styles/commonfeminine.css';
import Heders from '../components/Headers';
import Banner from '../components/Banner';
import Categorys from '../components/Categorys';
import FeatureProducts from '../components/products/FeatureProducts';
import MapProducts from '../components/products/mapProducts';
import ContinueShopping from '../components/products/ContinueShopping';
import Products from '../components/products/Products';
import TopRatedProducts from '../components/products/TopRatedProducts';
import Footer from '../components/Footer';
import { get_category, get_products, get_reviews } from '../store/reducers/homeReducer';
import { useEnrichProducts } from '../components/products/enrichedProducts';

const Home = () => {
  const dispatch = useDispatch();
  
  const loaderList = useMemo(
    () => ['/images/Loader1.mp4', '/images/Loader2.mp4', '/images/Loader3.mp4'],
    []
  );
  const [loaderSrc] = useState(
    () => loaderList[Math.floor(Math.random() * loaderList.length)]
  );
  const [isLoading, setIsLoading]           = useState(true);
  const [isDataLoaded, setIsDataLoaded]     = useState(false);
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);

  const LOADER_WIDTH         = '150px';
  const LOADER_HEIGHT        = '200px';
  const LOADER_BORDER_RADIUS = '50px';
  const VIDEO_PLAYBACK_RATE  = 2.2;
  const MIN_LOADER_TIME_MS   = 3000;

  useEffect(() => {
    document.body.style.overflow = isLoading ? 'hidden' : 'auto';
  }, [isLoading]);

  useEffect(() => {
    async function fetchAll() {
      try {
        await Promise.all([
          dispatch(get_products()),
          dispatch(get_category()),
          dispatch(get_reviews())
        ]);
      } catch (err) {
        console.error('Error loading home data', err);
      } finally {
        setIsDataLoaded(true);
      }
    }
    fetchAll();
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeElapsed(true), MIN_LOADER_TIME_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isDataLoaded && minTimeElapsed) setIsLoading(false);
  }, [isDataLoaded, minTimeElapsed]);

  const { products, latest_product, topRated_product, discount_product } = useSelector(s => s.home);
  const enhancedProducts = useEnrichProducts(products);
  const [enhancedLatest, setEnhancedLatest]     = useState([]);
  const [enhancedTopRated, setEnhancedTopRated] = useState([]);
  const [enhancedDiscount, setEnhancedDiscount] = useState([]);
  // … your existing enrichment effects …

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div style={{ width: LOADER_WIDTH, height: LOADER_HEIGHT, overflow: 'hidden', borderRadius: LOADER_BORDER_RADIUS }}>
          <video
            autoPlay
            loop
            muted
            preload="none"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onLoadedMetadata={e => (e.currentTarget.playbackRate = VIDEO_PLAYBACK_RATE)}
          >
            <source src={loaderSrc} type="video/mp4" />
          </video>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: 'var(--color-bg)' }}>
      <Heders />
      <Banner />

      {/* Shop by Category */}
      <div className="w-[85%] mx-auto my-2">
        {/* <img
          src="/images/shop-by-category-banner.png"
          alt="Shop by Category"
          className="w-full object-cover rounded-md banner-placeholder"
        /> */}
      </div>
      <Categorys />

      {/* Feature Products */}
      <div className="py-2 bg-amber-600 bg-opacity-10">
        <FeatureProducts products={enhancedProducts} />
      </div>

      {/* Top Rated */}
      <div className="py-5">
        <TopRatedProducts />
      </div>

      {/* Shop by Maps */}
     

      {/* Continue Shopping */}
      <div className="py-4 bg-amber-600 bg-opacity-20">
        <ContinueShopping />
      </div>

       <div className="w-[85%] mx-auto my-8">
        <img
          src="/images/shop-by-maps-banner.png"
          alt="Shop by Maps"
          className="w-full object-cover rounded-md banner-placeholder"
        />
      </div>
      <MapProducts />

      {/* Latest / TopRated / Discount Grids */}
      <div className="py-10 w-[85%] mx-auto grid grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
        <Products title="Latest Product" products={enhancedLatest} />
        <Products title="Top Rated Product" products={enhancedTopRated} />
        <Products title="Discount Product" products={enhancedDiscount} />
      </div>

      

      <Footer />
    </div>
  );
};

export default Home;
